const defaultModuleApiBase = "https://modules-api.poc.abtastylab.com";

let moduleApiBase = defaultModuleApiBase;

function getModuleApiBase() {
  return moduleApiBase;
}

function setModuleApiBase(url) {
  if (typeof url === "string" && url.trim()) {
    moduleApiBase = url;
  }
}

export { getModuleApiBase, setModuleApiBase };
